<template>
  <div>
    <CCard>
      <CCardHeader>
        <CButton @click="saveData" :color="saveButton.color" :disabled="saveDisabled" class="float-right">
          <CIcon :name="saveButton.icon" size="sm" class="mr-1"/>
          {{ saveButton.text }}
        </CButton>
        <h3>Settings</h3>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol><h4>Labels</h4></CCol>
        </CRow>
        <CRow class="border-top pt-4">
          <CCol><h5>iOS splash screen</h5></CCol>
        </CRow>
        <CRow>
          <CCol sm="6">
            <CInput
                label="Button label"
                placeholder="Enter a button label"
                v-model="labels.splash_screen.ios.button_label"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="12">
            <CTextarea
                label="Text label"
                placeholder="Enter a text label"
                v-model="labels.splash_screen.ios.text_label"
            />
          </CCol>
        </CRow>
        <CRow class="border-top pt-4">
          <CCol><h5>Android splash screen</h5></CCol>
        </CRow>
        <CRow>
          <CCol sm="6">
            <CInput
                label="Button label"
                placeholder="Enter a button label"
                v-model="labels.splash_screen.android.button_label"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="12">
            <CTextarea
                label="Text label"
                placeholder="Enter a text label"
                v-model="labels.splash_screen.android.text_label"
            />
          </CCol>
        </CRow>

        <CRow class="border-top pt-4">
          <CCol><h5>Welcome screen</h5></CCol>
        </CRow>
        <CRow v-for="(key, index) in Object.keys(labels.welcome_screen)" :key="index">
          <CCol sm="6">
            <CInput
                :label="key.replaceAll('_', ' ')"
                v-model="labels.welcome_screen[key]"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="12">
            <CTextarea
                label="Onboarding text tooltip timeline icon"
                placeholder="Enter a text label"
                v-model="labels.tooltips.timeline"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="12">
            <CTextarea
                label="Onboarding text tooltip search icon"
                placeholder="Enter a text label"
                v-model="labels.tooltips.search"
            />
          </CCol>
        </CRow>

        <CRow class="border-top pt-4">
          <CCol><h5>Enter email screen</h5></CCol>
        </CRow>
        <CRow>
          <CCol sm="12">
            <CTextarea
                rows="6"
                label="Disclaimer"
                placeholder="Enter the disclaimer text"
                v-if="labels.enter_email_screen"
                v-model="labels.enter_email_screen.disclaimer"
            />
          </CCol>
        </CRow>
        <CRow class="border-top pt-4">
          <CCol><h4>Help url</h4></CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput label="Help url" placeholder="https://service.nrc.nl/" v-model="help_url"/>
          </CCol>
        </CRow>
        <CRow class="border-top pt-4">
          <CCol><h4>Search screen</h4></CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput
                label="Disclaimer"
                placeholder=""
                v-model="labels.search_screen.disclaimer"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput
                label="Label for categories"
                placeholder=""
                v-model="labels.search_screen.category_label"
            />
          </CCol>
        </CRow>
        <CRow class="border-top pt-4">
          <CCol><h4>Timeline help</h4></CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput
                label="Help for swipe left"
                placeholder=""
                v-model="labels.timeline_screen.swipe_left"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput
                label="Help for swipe right"
                placeholder=""
                v-model="labels.timeline_screen.swipe_right"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput
                label="Help for stacking"
                placeholder=""
                v-model="labels.timeline_screen.stacking"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput
                label="Help for playlists"
                placeholder=""
                v-model="labels.timeline_screen.playlist"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput
                label="Change default name for timeline playlist (this will rename people's timeline in the database)"
                placeholder=""
                v-model="labels.timeline_screen.timeline_playlist_name"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput
                label="Override timeline playlist diplay title (this will show in the 2022 app and does not rename the actual playlist)"
                placeholder=""
                v-model="labels.timeline_screen.timeline_playlist_title_override"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput
                label="Override name for default empty playlist"
                placeholder=""
                v-model="labels.timeline_screen.default_empty_playlist_name"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput
                label="Override label for the list of playlists screen"
                placeholder=""
                v-model="labels.timeline_screen.list_of_playlists"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput
                label="Help text for sorting a playlist button (Android only)"
                placeholder=""
                v-model="labels.timeline_screen.sort_list"
            />
          </CCol>
        </CRow>
                <CRow>
          <CCol><h4>App Support</h4></CCol>
        </CRow>
        <CRow class="border-top pt-4">
        </CRow>
        <CRow>
          <CCol sm="6">
            <CSelect
                label="Force upgrade"
                :value.sync="app_support.force"
                :options="[true, false]"
                description="Force upgrade? Set to false to make the modal dismissable"
        ></CSelect>

          </CCol>
        </CRow>
        <CRow>
          <CCol sm="6">
            <CInput
                label="Title"
                placeholder="Enter a title"
                v-model="app_support.title"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="12">
            <CTextarea
                label="Body"
                placeholder="Enter a body"
                v-model="app_support.body"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="6">
            <CInput
                label="Button label"
                placeholder="Enter a button label"
                v-model="app_support.button_label"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="6">
            <CInput
                label="Minimum version Android"
                placeholder="Enter a minimum version"
                v-model="app_support.minimum_version_android"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="6">
            <CInput
                label="Minimum version iOS"
                placeholder="Enter a minimum version"
                v-model="app_support.minimum_version_ios"
            />
          </CCol>
        </CRow>
                <CRow>
          <CCol sm="6">
            <CSelect
                label="Use the 'exclusive' style podcast detail screen for podcasts owned by you"
                :value.sync="app_support.use_exclusive_podcast_detail"
                :options="[true, false]"
                description="Use the 'exclusive' style podcast detail screen for podcasts owned by you"
            />
          </CCol>
        </CRow>
        <CRow class="border-top pt-4">
          <CCol><h5>Setup for Android Auto</h5></CCol>
        </CRow>
        <CRow>
          <CCol sm="12">
            <p>Create a screen with screen_name "android_auto". This screen should contain 4 blocks (can be any, but
              this is what NRC uses):</p>
            <ul>
              <li> Nieuw (Items from auto-fill function Show recent episodes of our own podcasts)</li>
              <li> Afspeellijst (Items from auto-fill function Toon Timeline playlist van de gebruiker in dit blok).
                The block hook (block.system_name) for this one should be set to android_auto_timeline
              </li>
              <li> NRC (Items from auto-fill function Show all podcasts owned by us)</li>
              <li> Volgend (Items from auto-fill function User subscribed podcasts)</li>
            </ul>

            <p>An icon, block hook and auto-fill function can all be set on the edit block screen.</p>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
const defaultState = {
  labels: {
    welcome_screen: {
      heading: '',
      intro: '',
      audio_url: '',
      audio_image_url: '',
      audio_heading: '',
      audio_subheading: '',
      register_button_label: '',
      login_button_label: '',
      onboarding_heading: '',
      onboarding_heading_returning: '',
      onboarding_intro: '',
      onboarding_intro_returning: '',
      onboarding_image_url: '',
      onboarding_dialog_heading: '',
      onboarding_dialog_heading_returning: '',
      onboarding_dialog_affirmative: '',
      onboarding_dialog_negative: '',
    },
    splash_screen: {
      ios: {
        button_label: '',
        text_label: '',
      },
      android: {
        button_label: '',
        text_label: '',
      },
    },
    enter_email_screen: {
      disclaimer: '',
    },
    search_screen: {
      disclaimer: "",
      category_label: ""
    },
    timeline_screen: {
      swipe_left: "",
      swipe_right: "",
      stacking: "",
      playlist: "",
      timeline_playlist_name: "",
      timeline_playlist_title_override: "",
      default_empty_playlist_name: "",
      list_of_playlists: "",
      sort_list: "",
    },
    tooltips: {
      timeline: '',
      search: '',
    }
  },
  help_url: '',
  app_support: {
    force: false,
    title: '',
    body: '',
    button_label: '',
    minimum_version_android: 0,
    minimum_version_ios: "",
    use_exclusive_podcast_detail: true,
  }
}

export default {
  name: 'Settings',
  data() {
    return {
      labels: defaultState.labels,
      help_url: defaultState.help_url,
      app_support: defaultState.app_support,
      saveDisabled: true,
      saveButtons: [
        {color: 'secondary', text: 'Saved', icon: 'cil-check-alt'},
        {color: 'danger', text: 'Save', icon: 'cil-save'},
      ],
    }
  },
  components: {},
  mounted() {
    this.getData()
  },
  destroyed() {
    this.$store.dispatch('closeError')
  },
  watch: {
    help_url: {
      deep: true,
      handler(val, oldVal) {
        if (oldVal.length == 0) {
          return
        }
        this.saveDisabled = false
      },
    },
    app_support: {
      deep: true,
      handler() {
        this.saveDisabled = false
      },
    },
    labels: {
      deep: true,
      handler(val, oldVal) {
        if (oldVal.length == 0) {
          return
        }
        this.saveDisabled = false
      },
    },
  },
  computed: {
    saveButton() {
      return this.saveButtons[this.saveDisabled ? 0 : 1]
    },
  },
  methods: {
    getData() {
      this.$api
          .get('settings')
          .then(response => {
            this.parseData(response.data)
          })
          .then(() => (this.saveDisabled = true))
          .catch(error => this.$store.dispatch('throwError', error))
    },

    /**
     * Parse response data and if empty overwrite with defaults
     */
    parseData(data) {
      const {help_url, labels, app_support} = data
      this.help_url = help_url || defaultState.help_url
      this.labels = {
        ...defaultState.labels,
        ...labels,
      }
      this.app_support = {
        ...defaultState.app_support,
        ...app_support,
      }
    },

    saveData() {
      this.$api
          .post('settings', {
            help_url: this.help_url,
            app_support: this.app_support,
            labels: this.labels,
          })
          .then(() => {
            this.saveDisabled = true
          })
          .catch(error => this.$store.dispatch('throwError', error))
    },
  },
}
</script>
